import { RouteConfig } from 'vue-router';
import { AUTH_STATE } from '@/config';

export default [
  {
    path: '/logs',
    meta: { tabbar: 'secret/user', auth: AUTH_STATE.LOGGED_IN },
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/common/main'),
      footer: () => import('@/views/common/footer'),
    },
    redirect: { name: 'logs_point' },
    children: [
      {
        name: 'logs_point',
        path: 'point',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '积分日志' },
        component: () => import('@/views/logger/logger.vue'),
      },
      {
        name: 'logs_coin',
        path: 'coin',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '海鳗币日志' },
        component: () => import('@/views/logger/logger.vue'),
      },
      {
        name: 'logs_pay',
        path: 'pay',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '付费日志' },
        component: () => import('@/views/logger/logger.vue'),
      },
    ],
  },
] as RouteConfig[];
